// import messageBox from '../composables/messageBox'

const getErrCodeMsg = (code: number) => {
  const app = useNuxtApp()
  if (code === 300612) {
    return
  }
  if (code === 300017 || code === 300015) {
    code = 300020
  } else if (code === 401 || code === -27) {
    code = -8
  }
  const msg = app.$i18n.t(`errCode-${code}`) || app.$i18n.t(`network-err`)
  // const title = app.$i18n.t(`network-err`)
  // messageBox.error(title, msg)
  // showFailToast(msg)
  showNotify({ message: msg })
}

export default defineNuxtPlugin(() => {
  // const userAuth = useCookie("token");
  const config = useRuntimeConfig()

  const $fetchApi = $fetch.create({
    baseURL: config.public.VUE_APP_BASE_API as string,
    onRequest({ options }) {
      // let Authorization = ''
      // // TODO 服务端请求不需要传递token吗
      // if (import.meta.client) {
      //   Authorization = localStorage.getItem('token') || ''
      // }
      // 保留调用方传入的请求头，原生容器页面会在调用时注入上下文。
      options.headers = { ...options.headers }
    },
    onResponse({ response }) {
      // 处理响应数据
      if (!response._data) {
        if (import.meta.client) {
          const app = useNuxtApp()
          const title = app.$i18n.t(`network-err`)
          const msg = app.$i18n.t(`network-err-try`)
          messageBox.error(title, msg)
        }
        return new Error('Network error, please try again later.')
      }
      if (response._data.code !== 0) {
        if (import.meta.client) {
          getErrCodeMsg(response._data.code)
        }
      }
      return response._data
    },
    onRequestError({ error }) {
      // 处理请求错误
      console.warn('request error', error)
    },
    onResponseError({ response }) {
      // 处理响应错误
      console.warn('Response error', response)
    }
  })

  return {
    provide: {
      fetchApi: $fetchApi
    }
  }
})
